import angular from 'angular';
import 'angular-filter';
import 'angular-ui-router';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './header-campaigns.jade';

export class HeaderCampaignsController {
  /* @ngInject */
  constructor($state, $stateParams, CampaignsResource) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.CampaignsResource = CampaignsResource;
    this.getCampaigns();
  }

  getCampaigns() {
    return this.CampaignsResource.getList({game_id: this.$stateParams.gameId})
      .then((res) => this.campaigns = res);
  }

  goToCampaign(campaign) {
    let params = _.merge({}, this.$stateParams, {id: campaign.id});

    if (this.$state.current.name == 'app.campaigns.explore' && campaign.type != this.campaign.type) {
      if (campaign.type == 'Engagement') {
        params.axisName = 'targeted_players';
      } else {
        params.axisName = 'clicks';
      }
    }

    if (this.$state.current.name == 'app.campaigns.new') {
      this.$state.go('app.campaigns.edit', params);
    } else {
      this.$state.go(this.$state.current.name, params);
    }
  }
}

export function HeaderCampaignsComponent() {
  return {
    template,
    controller: HeaderCampaignsController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      campaign: '='
    },
    bindToController: true,
    link: function (scope, element) {
      element.addClass('c-header-primary__item c-header-primary__item--fill');
    }
  };
};

export default angular.module('header.campaigns', [
  'ui.router',
  'ui.select',
  'angular.filter',
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('headerCampaigns', HeaderCampaignsComponent);


/** WEBPACK FOOTER **
 ** ./src/common/header/header-campaigns.js
 **/